module.exports = __webpack_public_path__ + "static/media/окно.d29e14c3.jpg";